import * as modelSrcs from "url:../../models/exported/*.gltf";
import content from "../../content.json";

import * as classes from "./look-viewer-canvas.module.scss";
import { useContext, useEffect, useState } from "react";
import ViewerScene from "../../scene/ViewerScene";
import WebGLView from "../../WebGLView";
import { ActionType, AppContext } from "../../contexts/AppContext";

const LookViewerCanvas = ({ name }) => {
  const { dispatch } = useContext(AppContext);
  const [isMouseDown, setIsMouseDown] = useState(false);
  useEffect(() => {
    let scene: ViewerScene;

    const init = async () => {
      dispatch({ type: ActionType.SetIsViewerLoading, value: true });
      (window as any).webGlViewLookViewer = new WebGLView(
        document.querySelector(".canvas-look"),
        scene
      );
      scene = new ViewerScene(
        modelSrcs[content.looks[name].glb],
        document.querySelector(".canvas-look")
      );

      await scene.init();
      await (window as any).webGlViewLookViewer.init();
      (window as any).webGlViewLookViewer.updateScene(scene);

      dispatch({ type: ActionType.SetIsViewerLoading, value: false });
    };
    init();

    return () => {
      dispatch({ type: ActionType.SetIsViewerLoading, value: false });
      (window as any).webGlViewLookViewer.dispose();
      scene.dispose();
    };
  }, []);
  return (
    <canvas
      style={{ cursor: isMouseDown ? "grabbing" : "grab" }}
      onMouseDown={() => setIsMouseDown(true)}
      onMouseUp={() => setIsMouseDown(false)}
      className={`canvas-look ${classes.root}`}
    ></canvas>
  );
};

export default LookViewerCanvas;
